import { fg } from '@atlassian/jira-feature-gating';
import type {
	FormFieldValues,
	IssueOrRequestType,
	SelectedProject,
} from '@jira/issue-create__issue-create-common-types/src/common/types/index.tsx';
import { REQUEST_TYPE } from '@jira/issue-create__issue-create-common-types/src/common/constants/graphql-field-types.tsx';
import type { QueryVariables } from '../../../common/types/index.tsx';
import { normalizeDefaultValues } from './normalizeDefaultValues.tsx';

export const getQueryVariables = (
	selectedProject: SelectedProject,
	selectedIssueType: IssueOrRequestType,
	defaultValues?: FormFieldValues,
): QueryVariables => {
	const projectId = selectedProject?.value || null;
	let issueTypeId = null;
	let requestTypeKey = null;
	if (selectedIssueType) {
		issueTypeId =
			selectedIssueType.type === REQUEST_TYPE
				? selectedIssueType.issueTypeId
				: selectedIssueType.value;
		requestTypeKey =
			// @ts-expect-error - TS2339 - Property 'requestTypeKey' does not exist on type 'IssueType | RequestType'.
			selectedIssueType.requestTypeKey !== undefined
				? // @ts-expect-error - TS2339 - Property 'requestTypeKey' does not exist on type 'IssueType | RequestType'.
					selectedIssueType.requestTypeKey
				: null;
	}
	return {
		project: projectId ? { projectId } : null,
		issueType: issueTypeId !== null ? { issueTypeId } : null,
		requestType: requestTypeKey !== null ? { key: requestTypeKey } : null,
		// Normalise empty `defaultValues` ({}) to null so an issue type / project
		// revisited with no user input produces the same Apollo cache key as the
		// initial load, restoring cache hits instead of redundant network calls.
		defaultValues: fg('nike_united_add_cache_and_network')
			? normalizeDefaultValues(defaultValues)
			: defaultValues || null,
		withNumberFormat: true,
	};
};
